module.exports = __webpack_public_path__ + "static/media/yogi2.2d24b205.png";